export const iconFontAwesomeAlertBell = (
	<i className="fa-solid fa-bell"></i>
);
